import { render, staticRenderFns } from "./Sperrtage.vue?vue&type=template&id=290172cb"
import script from "./Sperrtage.vue?vue&type=script&lang=js"
export * from "./Sperrtage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports